export default class AccordionPanel extends Component {
  constructor(props) {
    super(props)
    this.state = { loadBody: props.openByDefault || false }
    this.togglePanelOpen = this.togglePanelOpen.bind(this)
  }

  togglePanelOpen() {
    this.setState({ loadBody: !this.state.loadBody })
  }

  render() {
    const { PanelBody, title, panelId } = this.props
    const { loadBody } = this.state

    return (
      <div className="cb-accordion-container" id={panelId}>
        <a href="#" className="cb-accordion-heading" role="button" onClick={this.togglePanelOpen}>
          <div className="cb-accordion-heading-title">
            <span>{typeof title === 'string' ? title : <this.props.title />}</span>
            <div className="cb-accordion-icon">
              <span className="line top" />
              <span className="line bottom" />
            </div>
          </div>
        </a>
        <div className={`cb-accordion-panel transition${loadBody ? ' cb-in' : ''}`} role="region">
          <div className="cb-accordion-panel-content">
            {loadBody ? <PanelBody panelIsOpen={loadBody} /> : null}
          </div>
        </div>
      </div>
    )
  }
}
